<template>
  <div class="pageLayout">
    <div class="sky">
      <div class="software container">
        <h1>LETC Software</h1>
        <div class="container-fluid">
          <p>
            <em>
              Software and services built by LETC that you can use today.
            </em>
          </p>
          <div class="product" v-for="item in products" :key="item.name">
            <h2>{{ item.name }}</h2>
            <p>{{ item.description }}</p>
            <h4><em>How to access {{ item.name }}:</em></h4>
            <ol>
              <li>
                Download and install the Tor Browser from
                <a href="https://www.torproject.org/download/" target="_blank" rel="noopener">torproject.org</a>.
              </li>
              <li>Open the Tor Browser and wait for it to connect to the Tor network.</li>
              <li>
                In the Tor Browser address bar, enter the address below:
                <div class="onion">{{ item.onionUrl }}</div>
              </li>
            </ol>
            <p class="note">
              <em>
                This address works only in the Tor Browser. It will not open
                in a regular browser.
              </em>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SoftwareView",
  data() {
    return {
      // Add new LETC software here; each entry gets its own section on the page.
      products: [
        {
          name: "SecureSend",
          description:
            "SecureSend is LETC's secure file and message exchange service, hosted as a Tor onion service.",
          onionUrl:
            "http://vrz6gzoa5m3hdvrfb6hn5hfqqxh5gziqk2kyrwp3riiwfkvygufuniad.onion:8080/",
        },
      ],
    };
  },
};
</script>

<style scoped>
.pageLayout {
  min-height: 800px;
}

.sky {
  background-image: url("../assets/LeadingEdgeLeft.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 600px;
  width: auto;
  height: auto;

  padding-top: 50px;
  padding-bottom: 50px;
}

h1 {
  color: white;
}

.container-fluid {
  text-align: left;
  padding: 20px;
  margin: 2px;
  background-color: antiquewhite;
  color: black;
  opacity: 0.8;
}

.product {
  background-color: aqua;
  color: black;
  margin: 10px;
  padding: 10px;
  opacity: 0.9;
}

.onion {
  font-family: Consolas, "Courier New", monospace;
  background-color: white;
  border: 1px solid #333;
  border-radius: 4px;
  padding: 6px 10px;
  margin-top: 6px;
  word-break: break-all;
  user-select: all;
}

html,
body {
  height: 100%;
}
</style>
